import React from 'react';
import { Chip, ChipBackgroundColor, ChipSize } from '@amzn/stencil-react-components/chip';
import { DetailedCheckbox } from '@amzn/stencil-react-components/form';
import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { ComparisonGroupType, PolicyMetadata } from 'src/models';
import { Text } from '@amzn/stencil-react-components/text';
import { useCreateExecutionWorkflowContext } from '../context';

interface PolicyTileProps {
  viewMode?: boolean;
  checked?: boolean;
  group: ComparisonGroupType;
  policyMetadata: PolicyMetadata;
}

export const PolicyTile: React.FC<PolicyTileProps> = ({ viewMode, policyMetadata, group }) => {
  const { selectedPolicies, updateSelectedPolicies } = useCreateExecutionWorkflowContext();

  const isSelected = selectedPolicies[group].some((p) => p.policyId === policyMetadata.policyId);

  const PolicyTitle = () => {
    return (
      <Row justifyContent="space-between" margin="S100" width="100%" display="flex" flexWrap="wrap">
        <Row margin={'auto 0px'}>
          <Text fontWeight="bold" fontSize="T300">
            {policyMetadata.name}
          </Text>
        </Row>
        <Row id={`${policyMetadata.policyId}-${group}-chips`} aria-hidden={true} display="flex" flexWrap="wrap">
          <Spacer width={'S200'} />
          {policyMetadata?.domains?.map((domain) => (
            <>
              <Chip key={`${policyMetadata.policyId}-${domain}`} size={ChipSize.Small}>
                {domain}
              </Chip>
              <Spacer width={'S200'} />
            </>
          ))}
          <Chip size={ChipSize.Small} backgroundColor={ChipBackgroundColor.Blue}>
            {policyMetadata.sourceType}
          </Chip>
          <Spacer width={'S200'} />
        </Row>
      </Row>
    );
  };

  const PolicyDetails = () => {
    return (
      <Col id={`${policyMetadata.policyId}-${group}-details`} margin="S100" width="100%" aria-hidden={true}>
        <Col minHeight={'S500'}>{policyMetadata.description}</Col>
      </Col>
    );
  };

  return (
    <Col margin="S200">
      <DetailedCheckbox
        checked={isSelected}
        disabled={viewMode}
        onChange={(event) => {
          updateSelectedPolicies(group, policyMetadata, event.target.checked);
        }}
        renderTitle={() => <PolicyTitle />}
        titleText={policyMetadata.name}
        value={policyMetadata.policyId}
        details={<PolicyDetails />}
        aria-describedby={`${policyMetadata.policyId}-${group}-chips ${policyMetadata.policyId}-${group}-details`}
      />
    </Col>
  );
};
